import ProfilePageSkeleton from "./ProfilePageSkeleton";

export default ProfilePageSkeleton;
